//@ts-nocheck

import React from "react";

import * as S from './Tag.styles'

import { Paragraph } from "../Typography/Typography.component";
import Icon from "../Icon/Icon.component";

export interface TagProps {
  items: TagItem[];
}

export type TagSize = 'default' | 'small'

export interface TagItem {
  colorScheme: string;
  text: string;
  icon?: string;
  iconPosition?: 'left' | 'right';
  size?: TagSize;
}

const Tag = ({ items }: TagProps) => {

  return (
    <S.TagWrapper>
      {items.map(({ colorScheme, text, icon = null, iconPosition = 'left', size = 'default' }) => (
        <S.Tag 
          key={text}
          colorScheme={colorScheme}
          $size={size}
        >
          {
            (icon && iconPosition === 'left') && (
              <Icon name={icon} />
            )
          }

          <Paragraph 
            content={text}
            typo={'paragraphMD'}
            colorScheme={colorScheme}
          />

          {
            (icon && iconPosition === 'right') && (
              <Icon name={icon} />
            )
          }
        </S.Tag>
      ))}
    </S.TagWrapper>
  )
}

export default Tag